<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<!-- <el-tabs class="mt-3" v-model="type" @tab-click="handleClick" type="card">
		   <el-tab-pane   v-for="item in agentData.cloud" :key="item.id" :label="item.name" :name="String(item.id)"></el-tab-pane>
		   
		 </el-tabs> -->
		
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						
						<el-form-item :label="$t('cdn.domain')" class="mb-0">
							<el-select v-model="from.domain" size="small" filterable :placeholder="$t('system.select')">
								<!-- <el-option  :label="$t('status.all')" value=""> -->
								</el-option>
								<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain + ' - 【' +item.name+ '】'" :value="item.domain">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.type" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.now')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						
						
						
						<el-form-item label="Stream" class="mb-0">
							<el-input size="small" v-model="from.stream" ></el-input>
						</el-form-item>
						
						
						<el-form-item  label="AppName" class="mb-0">
							<el-input size="small" v-model="from.appname"></el-input>
						</el-form-item>
						
						
						
						<el-form-item v-if="ac_type=='3'" :label="$t('live.historyTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('live.addJin')}}</el-button>
						
						<span class="ml-3" @click="apiModel = true" style="cursor: pointer;color: rgb(64, 158, 255);font-size: 14px;">
													  
							<i class="el-icon-warning-outline mr-1"></i>{{$t('record.apiTis')}}
						</span>
					</div>
					
					
			</template>
		</div>
		
		
		  
		 <el-tabs  class="mt-3" v-model="ac_type" @tab-click="handleClick" >
		     <el-tab-pane  :label="$t('live.onlineStream')" name="1"></el-tab-pane>
		     <el-tab-pane  :label="$t('live.history')" name="3"></el-tab-pane>
		     <el-tab-pane  :label="$t('live.jinStream')" name="2"></el-tab-pane>
		</el-tabs>

		<!-- 表格 -->
		<div class="" style="padding-bottom:20px">
			<el-table  v-show="ac_type!='3'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				
				<el-table-column  align="center" prop="StreamName" label="StreamName">
				</el-table-column>
				
				
				<el-table-column  align="center" prop="DomainName" :label="$t('cdn.domain')">
				</el-table-column>
	
				
				<el-table-column  align="center" prop="AppName" label="AppName">
				
				</el-table-column>
				
				<el-table-column align="center" prop="status" :label="$t('status.status')">
					<template slot-scope="scope">
						
						<span class="text-success" v-if="ac_type=='1'">{{$t('live.liveOn')}}</span>
						<span class="text-danger" v-if="ac_type=='2'">{{$t('live.liveJin')}}</span>
					</template>
				</el-table-column>		

				
				
				<el-table-column align="center" width="180" prop="push_time" :label="ac_type=='1'?$t('live.push_time'):$t('live.hui_time')">
				</el-table-column>
				
			
				
			
		
				<el-table-column :width="layout.user.type==1?220:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							
							
							<el-button v-if="ac_type=='1'" @click="getPlayUrl(scope.row)"  size="mini" plain type="info">{{$t('live.look')}}</el-button>
							<el-button v-auth="'checkLiveData'" @click="getToTotal(scope.row)"  size="mini" plain type="success">{{$t('live.streamData')}}</el-button>
							<el-button v-if="ac_type=='1'" size="mini" plain type="danger" v-auth="'edit'+auth_val" @click="openModel(scope.row)">{{$t('live.jintui')}}</el-button>
							
							
							<el-button v-if="ac_type=='2'" size="mini" plain type="success" v-auth="'edit'+auth_val" @click="huifu(scope.row)">{{$t('live.hui')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			
			
			
			
			<el-table v-show="ac_type=='3'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				
				<el-table-column  align="center" prop="StreamName" label="StreamName">
				</el-table-column>
				
				
				<el-table-column  align="center" prop="DomainName" :label="$t('cdn.domain')">
				</el-table-column>

				
				
				
				<el-table-column  align="center" prop="AppName" label="AppName">
				
				</el-table-column>
				
			
				
				
				
				
				<el-table-column align="center" width="180" prop="start" :label="$t('system.startTime')">
				</el-table-column>
				<el-table-column align="center" width="180" prop="end" :label="$t('system.endTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="Duration" :label="$t('live.streamTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="IP" :label="$t('live.streamIp')">
				</el-table-column>
				
				<el-table-column show-overflow-tooltip="" align="center" width="180" prop="StreamBreakReason" :label="$t('live.endRemark')">
				</el-table-column>
				
			
				
			
					
				<!-- <el-table-column :width="layout.user.type==1?220:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							
							
							<el-button v-auth="'checkLiveData'" @click="getToTotal(scope.row)"  size="mini" plain type="success">{{$t('live.streamData')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column> -->
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('live.jinStream') : $t('live.jinStream')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				
				<el-form-item   :label="$t('cdn.domain')" prop="domain">
					
					<el-select v-if="editIndex==-1" v-model="form.domain" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain" :value="item.domain">
						</el-option>
					</el-select>
					
					
					<span v-else>{{form.domain}}</span>
					
					
					
				</el-form-item>
				<el-form-item   label="AppName" prop="appname">
					
					<el-input v-if="editIndex==-1" v-model="form.appname" :placeholder="$t('record.app')" clearable size="small" style="width: 85%;"></el-input>
					<span v-else>{{form.appname}}</span>
				</el-form-item>
				<el-form-item   label="StreamName" prop="stream">
					<el-input v-if="editIndex==-1" v-model="form.stream" :placeholder="$t('record.stream')" clearable size="small" style="width: 85%;"></el-input>
					<span v-else>{{form.stream}}</span>
				</el-form-item>
				
				<el-form-item  :label="$t('live.hui_time')" prop="date">
					<el-date-picker
					  v-model="form.date"
					  type="datetime"
					  placeholder="选择日期">
					</el-date-picker>
					<span class="ml-2">{{$t('live.jin_tis')}}</span>
				</el-form-item>
				
				
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('live.look')"
			:visible.sync="playModel"
			top="5vh"
			@opened="onDialogOpened"
			  @close="onDialogClosed"
			:width="layout.is_phone?'360px':'800px'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			
			<div v-loading="playData.load">
			      <!-- 使用 video.js 播放器容器 -->
			      <div v-if="isDialogOpened" class="video-wrapper">
			        <video
			          ref="videoPlayer"
			          class="video-js vjs-default-skin"
			          controls
			          preload="auto"
			        ></video>
			      </div>

			    </div>
			
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="playModel = false">{{$t('cdnd.close')}}</el-button>
				
			</div>
		</el-dialog>
		
		
		
		<el-dialog :close-on-click-modal="false"
				:title="$t('record.apiTis')"
				:visible.sync="apiModel"
				top="5vh"
				:width="layout.is_phone?'90%':'80%'"
				:append-to-body="true"
				custom-class="custom-dialog">
				<!-- 表单内容 -->
				
				 <template>
					 
					 <el-tabs  v-model="apiType" type="card">
					    <el-tab-pane  :label="$t('ban.apiType1')" name="1"></el-tab-pane>
					    <el-tab-pane  :label="$t('ban.apiType2')" name="2"></el-tab-pane>
					    <el-tab-pane  :label="$t('ban.apiType3')" name="3"></el-tab-pane>
					    
					  </el-tabs>
					  
					  
					<!-- 创建录制任务 -->  
				<div class="doc-page" v-if="apiType=='1'">
					 <el-card shadow="hover">
					   <h4>{{$t('ban.apitis1')}}</h4>
					   <p class="desc">{{$t('ban.apitis2')}}</p>
				 
					   <el-divider>{{$t('live.apitis3')}}</el-divider>
					   <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
						 <div style="font-size: 14px; line-height: 2;">
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
							 <span style="color: #409EFF; font-weight: bold;">{{info.api_url}}
							 <span class="iconCopy" @click="copyText(info.api_url)"><i class="iconfont icon-fuzhi"></i></span></span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
							 <span>POST</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
							 <span>application/json 或 x-www-form-urlencoded</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
							 <span>MD5</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.api_key}}
							   <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
							   <el-tooltip :content="$t('match.apiSetTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							   
							 </span>
						   </p>
						   
						   
						   <!-- <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.uid}}
							   <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
												   
							 </span>
						   </p> -->
										   
					   
						 </div>
					   </el-card>
		
				 
					   <el-divider>{{$t('live.apitis9')}}</el-divider>
					   <el-table :data="apiParamList" border style="width: 100%">
						 <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
						 <el-table-column prop="type" :label="$t('live.type')" width="100" />
						 <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
						 <el-table-column prop="desc" :label="$t('live.apitis18')" />
					   </el-table>
				 
					  <el-divider>{{$t('live.apitis19')}}</el-divider>
					  <el-card shadow="never" class="mb-3">
						<div class="text-block">
						  <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
					  
						  
						  <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
						  <ul>
							<li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
							<li><code>timestamp</code> {{$t('live.apitis25')}}</li>
							<li><code>nonce</code> {{$t('live.apitis26')}}</li>
							<li>{{$t('live.apitis27')}} <code>DomainName</code>、<code>AppName</code> 、<code>StreamName</code>{{$t('live.apitis28')}}</li>
						  </ul>
					  
						  <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
						  <ol>
							<li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
							<li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
							<li>{{$t('live.apitis35')}}：<br />
							  <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
							</li>
							<li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
							<li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
						  </ol>
					  
						  <el-descriptions :title="$t('live.apitis40')" :column="1" border>
							<el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
							<el-descriptions-item label="DomainName">tl.example.com</el-descriptions-item>
							<el-descriptions-item label="AppName">live</el-descriptions-item>
							<el-descriptions-item label="StreamName">test001</el-descriptions-item>
						
							<el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
							<el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
							
							
						  </el-descriptions>
					  
						  <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
						  <el-card shadow="never">
							AppName=live<br />
							DomainName=tstl.bjingqk.com<br />
							StreamName=test001<br />
							nonce=abcxyz<br />
							timestamp=1720000000<br />
							
							</span>
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
						  <el-card shadow="never">
							abc1234561720000000abcxyzAppNameliveDomainNametl.example.comStreamNametest001nonceabcxyztimestamp1720000000
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
						  <el-card shadow="never">
							sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >c3f1e11e8dfba47d96f3d67794ea0b8f</span>
								</span>
						  </el-card>
					  
						  
						</div>
					  </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		{
			"DomainName": "tstl.bjingqk.com",
			"AppName": "live",
			"StreamName": "test001",
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "c3f1e11e8dfba47d96f3d67794ea0b8f",
		}
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		{
			"code": 200,
			"msg": "success",
			"requestId": "mgw5zbdpcabb98eb2b6f3694"
		}
						  </pre>
						  
						  
						</el-card>
		
					   
					   
				 
				 
					  <el-divider >{{$t('live.apitis47')}}</el-divider>
					  <el-card   shadow="never" class="mb-3">
						<!-- <div style="font-weight: bold; margin-bottom: 10px;">{{$t('match.apitis9')}}</div> -->
						<el-table :data="[
						  { name: 'requestId', type: 'string', desc: $t('ban.apitis6') }
						  
						]" border style="width: 100%">
						  <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
						  <el-table-column prop="type" :label="$t('live.type')" width="120" />
						  <el-table-column prop="desc" :label="$t('live.apitis18')" />
						</el-table>
					  </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
					   <el-divider >{{$t('live.apitis60')}}</el-divider>
					   <el-card shadow="never">
						 <el-table :data="[
						   { code: 200, message: 'success', desc: $t('live.apitis61') },
						   { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
						   { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
						   { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
						   { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
						   { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
						 ]" border style="width: 100%">
						   <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
						   <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
						   <el-table-column prop="desc" :label="$t('live.apitis18')" />
						 </el-table>
					   </el-card>
					   
					 </el-card>
				   </div>
				   
				   <!-- 查询录制任务 -->
				   <div class="doc-page" v-if="apiType=='2'">
					 <el-card shadow="hover">
					   <h4>{{$t('ban.apitis7')}}</h4>
					   <p class="desc">{{$t('ban.apitis8')}}</p>
				 
					   <el-divider>{{$t('live.apitis3')}}</el-divider>
					   <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
						 <div style="font-size: 14px; line-height: 2;">
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
							 <span style="color: #409EFF; font-weight: bold;">{{info.api_url2}}
							 <span class="iconCopy" @click="copyText(info.api_url2)"><i class="iconfont icon-fuzhi"></i></span></span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
							 <span>POST</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
							 <span>application/json 或 x-www-form-urlencoded</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
							 <span>MD5</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.api_key}}
							   <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
							   <el-tooltip :content="$t('match.apiSetTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							   
							 </span>
						   </p>
						   
						   
						   <!-- <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.uid}}
							   <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
												   
							 </span>
						   </p> -->
										   
					   
						 </div>
					   </el-card>
		   
				 
					   <el-divider>{{$t('live.apitis9')}}</el-divider>
					   <el-table :data="apiParamList" border style="width: 100%">
						 <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
						 <el-table-column prop="type" :label="$t('live.type')" width="100" />
						 <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
						 <el-table-column prop="desc" :label="$t('live.apitis18')" />
					   </el-table>
				 
					  <el-divider>{{$t('live.apitis19')}}</el-divider>
					  <el-card shadow="never" class="mb-3">
						<div class="text-block">
						  <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
					  
						  
						  <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
						  <ul>
							<li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
							<li><code>timestamp</code> {{$t('live.apitis25')}}</li>
							<li><code>nonce</code> {{$t('live.apitis26')}}</li>
							<li>{{$t('live.apitis27')}} <code>DomainName</code>{{$t('live.apitis28')}}</li>
						  </ul>
					  
						  <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
						  <ol>
							<li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
							<li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
							<li>{{$t('live.apitis35')}}：<br />
							  <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
							</li>
							<li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
							<li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
						  </ol>
					  
						  <el-descriptions :title="$t('live.apitis40')" :column="1" border>
							<el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
							<el-descriptions-item label="DomainName">tl.example.com</el-descriptions-item>
							
						
							<el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
							<el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
							
							
						  </el-descriptions>
					  
						  <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
						  <el-card shadow="never">
							DomainName=tl.example.com<br />
							nonce=abcxyz<br />
							timestamp=1720000000<br />
							
							</span>
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
						  <el-card shadow="never">
							abc1234561720000000abcxyzDomainNametl.example.comnonceabcxyztimestamp1720000000
						  </el-card>
					  
						  <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
						  <el-card shadow="never">
							sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >5f07b373370cd3b37a8b545c043efc3b</span>
								</span>
						  </el-card>
					  
						  
						</div>
					  </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		   {
			"DomainName": "tl.example.com",
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "5f07b373370cd3b37a8b545c043efc3b",
		   }
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		   {
		       "code": 200,
		       "msg": "success",
		       "List": [
		           {
		               "DomainName": "tl.example.com",
		               "AppName": "live",
		               "StreamName": "test001",
		               "ResumeTime": "2025-11-08T16:00:00Z"
		           }
		       ],
		       "requestId": "mhok2it3f6271d52349bf5dc"
		   }
						  </pre>
						  
						  
						</el-card>
		   
					   
					   
				 
				 
					  <el-divider >{{$t('live.apitis47')}}</el-divider>
					  <el-card   shadow="never" class="mb-3">
						<div style="font-weight: bold; margin-bottom: 10px;">{{$t('record.apitis14')}}</div>
						<el-table :data="[
						  
						  { name: 'DomainName', type: 'string', desc: $t('live.type1') },
						  { name: 'AppName', type: 'string', desc: $t('live.apitis10') },
						  { name: 'StreamName', type: 'string', desc: $t('live.apitis11') },
						  { name: 'ResumeTime', type: 'string', desc: $t('ban.apitis17') },
						  
						]" border style="width: 100%">
						  <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
						  <el-table-column prop="type" :label="$t('live.type')" width="120" />
						  <el-table-column prop="desc" :label="$t('live.apitis18')" />
						</el-table>
					  </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
					   <el-divider >{{$t('live.apitis60')}}</el-divider>
					   <el-card shadow="never">
						 <el-table :data="[
						   { code: 200, message: 'success', desc: $t('live.apitis61') },
						   { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
						   { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
						   { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
						   { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
						   { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
						 ]" border style="width: 100%">
						   <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
						   <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
						   <el-table-column prop="desc" :label="$t('live.apitis18')" />
						 </el-table>
					   </el-card>
					   
					 </el-card>
				   </div>
				   
				   <!-- 删除录制任务 -->
				   <div class="doc-page" v-if="apiType=='3'">
					 <el-card shadow="hover">
					   <h4>{{$t('ban.apitis18')}}</h4>
					   <p class="desc">{{$t('ban.apitis19')}}</p>
				 
					   <el-divider>{{$t('live.apitis3')}}</el-divider>
					   <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
						 <div style="font-size: 14px; line-height: 2;">
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
							 <span style="color: #409EFF; font-weight: bold;">{{info.api_url3}}
							 <span class="iconCopy" @click="copyText(info.api_url3)"><i class="iconfont icon-fuzhi"></i></span></span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
							 <span>POST</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
							 <span>application/json 或 x-www-form-urlencoded</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
							 <span>MD5</span>
						   </p>
					   
						   <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.api_key}}
							   <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
							   
							   <el-tooltip :content="$t('match.apiSetTis')" effect="dark" placement="top">
									
									<el-button size="mini" type="text">
										 <i class="el-icon-warning-outline ml-2" style="font-size: 16px;"></i>
									</el-button>
									
								</el-tooltip>
							   
							 </span>
						   </p>
						   
						   
						   <!-- <p>
							 <strong style="width: 100px; display: inline-block; color: #F56C6C;">client：</strong>
							 <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
							   {{info.uid}}
							   <span class="iconCopy" @click="copyText(info.uid)"><i class="iconfont icon-fuzhi"></i></span>
												   
							 </span>
						   </p> -->
										   
					   
						 </div>
					   </el-card>
		   
				 
					   <el-divider>{{$t('live.apitis9')}}</el-divider>
					   <el-table :data="apiParamList" border style="width: 100%">
						 <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
						 <el-table-column prop="type" :label="$t('live.type')" width="100" />
						 <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
						 <el-table-column prop="desc" :label="$t('live.apitis18')" />
					   </el-table>
				 
					  <el-divider>{{$t('live.apitis19')}}</el-divider>
					  <el-card shadow="never" class="mb-3">
						<div class="text-block">
						  <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
					  
						  
						  <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
						  <ul>
							<li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
							<li><code>timestamp</code> {{$t('live.apitis25')}}</li>
							<li><code>nonce</code> {{$t('live.apitis26')}}</li>
							<li>{{$t('live.apitis27')}} <code>DomainName</code>、<code>AppName</code> 、<code>StreamName</code>{{$t('live.apitis28')}}</li>
						  </ul>
					  
						  <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
						  <ol>
							<li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
							<li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
							<li>{{$t('live.apitis35')}}：<br />
							  <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
							</li>
							<li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
							<li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
						  </ol>
					  
						  <el-descriptions :title="$t('live.apitis40')" :column="1" border>
							<el-descriptions-item label="key">
							abc123456
							
							</el-descriptions-item>
							<el-descriptions-item label="DomainName">tl.example.com</el-descriptions-item>
							<el-descriptions-item label="AppName">live</el-descriptions-item>
							<el-descriptions-item label="StreamName">test001</el-descriptions-item>
						
							<el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
							<el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
							
							
						  </el-descriptions>
					  
						  <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
						  <el-card shadow="never">
						  							AppName=live<br />
						  							DomainName=tstl.bjingqk.com<br />
						  							StreamName=test001<br />
						  							nonce=abcxyz<br />
						  							timestamp=1720000000<br />
						  							
						  							</span>
						  </el-card>
						  					  
						  <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
						  <el-card shadow="never">
						  							abc1234561720000000abcxyzAppNameliveDomainNametl.example.comStreamNametest001nonceabcxyztimestamp1720000000
						  </el-card>
						  					  
						  <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
						  <el-card shadow="never">
							sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
								<span >c3f1e11e8dfba47d96f3d67794ea0b8f</span>
								</span>
						  </el-card>
					  
						  
						</div>
					  </el-card>
					  
					 
						<!-- 4. 请求示例 -->
						<el-divider>{{$t('live.apitis45')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
		   {
			"DomainName": "tstl.bjingqk.com",
			"AppName": "live",
			"StreamName": "test001",
			"timestamp": 1720000000,
			"nonce": "abcxyz",
			"sign": "c3f1e11e8dfba47d96f3d67794ea0b8f",
		   }
						  </pre>
						  
						</el-card>
						
						<!-- 5. 响应示例 -->
						<el-divider>{{$t('live.apitis46')}}</el-divider>
						<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
						  <pre  style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
		   {
			"code": 200,
			"msg": "success",
			"requestId": "mgw5zbdpcabb98eb2b6f3694"
		   }
						  </pre>
						  
						  
						</el-card>
		   
					   
					   
				 
				 
					  <el-divider >{{$t('live.apitis47')}}</el-divider>
					  <el-card   shadow="never" class="mb-3">
						
						<el-table :data="[
						  { name: 'msg', type: 'string', desc: $t('record.apitis21') }
						  
						]" border style="width: 100%">
						  <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
						  <el-table-column prop="type" :label="$t('live.type')" width="120" />
						  <el-table-column prop="desc" :label="$t('live.apitis18')" />
						</el-table>
					  </el-card>
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
					  
				 
					   <el-divider >{{$t('live.apitis60')}}</el-divider>
					   <el-card shadow="never">
						 <el-table :data="[
						   { code: 200, message: 'success', desc: $t('live.apitis61') },
						   { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
						   { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
						   { code: 403, message: $t('match.apitis7'), desc: $t('match.apitis8') },
						   { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
						   { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
						 ]" border style="width: 100%">
						   <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
						   <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
						   <el-table-column prop="desc" :label="$t('live.apitis18')" />
						 </el-table>
					   </el-card>
					   
					 </el-card>
				   </div>
			   
				 </template>
		
		
				<div slot="footer" class="dialog-footer">
					<el-button @click="apiModel = false">{{$t('safe.close')}}</el-button>
					
				</div>
			</el-dialog>
		

	</div>
</template>
<script>
	import videojs from 'video.js';
	import 'video.js/dist/video-js.css';
	
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				apiType:'1',
				apiModel:false,
				playModel:false,
				playData:{
					load:false,
					url:''
				},
				info:{},
				isDialogOpened: false, 
				player: null,
				remarkModel:false,
				createModel: false,
				editIndex: -1,
				type:"4",
				ac_type:"1",
				//搜索數据
				from: {
					stream: '',
					appname:'',
					domain:'',
					one:'',
					type:-1,
					time:this.getTodayRange()
				},
				auth_val: 'Stream',
				odds:0,
				preUrl: "data/livestreamList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delAccount", //删除單条地址
				addUrl: "data/setStreamInfo", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:{tl:[]},
				tableData: [],
				form: {},
				form_remark:{
				},
				rules_remark:{
					remark: [{
						required: true,
						message: this.$t('accountList.inpStatusRemark'),
						trigger: 'blur',
					}],
				},
				rules: {
					appname: [{
						required: true,
						message: this.$t('record.inpapp'),
						trigger: 'blur',
					}],
					stream: [{
						required: true,
						message: this.$t('record.inpstream'),
						trigger: 'blur',
					}],
					domain: [{
						required: true,
						message: this.$t('record.selDomain'),
						trigger: 'blur'
					}],
					
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			}
			
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			apiParamList() {
			    const list = [
					{ name: 'DomainName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.type1'),com:true},
					{ name: 'AppName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis10'),del:true },
					{ name: 'StreamName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis11') ,del:true},
					
					{ name: 'AppName', type: 'string', required: this.$t('live.no'), desc: this.$t('live.apitis10'),check:true },
					{ name: 'StreamName', type: 'string', required: this.$t('live.no'), desc: this.$t('live.apitis11'),check:true },

			     
				  { name: 'ResumeTime', type: 'string', required: this.$t('live.no'), desc: this.$t('ban.apitis5') },
				  
				  
				  { name: 'PageNum', type: 'int', required: this.$t('live.no'), desc: this.$t('record.apitis9') ,check:true},
				  { name: 'PageSize', type: 'int', required: this.$t('live.no'), desc: this.$t('record.apitis10') ,check:true},
				  { name: 'startTime', type: 'string', required: this.$t('live.no'), desc: this.$t('ban.apitis11') ,check:true},
				  { name: 'endTime', type: 'string', required: this.$t('live.no'), desc: this.$t('ban.apitis12') ,check:true},
				 
			      
			      { name: 'timestamp', type: 'int', required: this.$t('live.yes'), desc: this.$t('live.apitis13') ,com:true},
			      { name: 'nonce', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis14') ,com:true},
			      { name: 'sign', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis15') ,com:true}
				  
				 
			    ];
			
			    return list.filter(item => {
			        if (this.apiType == '1') {
			          // 查询
			          return !item.check;
			        } 
					if (this.apiType == '2') {
					  // 查询
					  return item.check || item.com;
					} 
					if (this.apiType == '3') {
					  // 查询
					  return item.del || item.com;
					} 
			      });
			  }
		},
		created() {
			this.commonList('liveStream');
		},
		methods: {
			getTodayRange() {
			      const today = new Date();
			      const todayStr = today.toISOString().split('T')[0]; // 格式化为 YYYY-MM-DD
			      return [todayStr, todayStr];
			    },
			
			huifu(item) {
				console.log(item)
				this.$confirm(this.$t('live.huiConfig'), this.$t('live.hui1'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post(this.addOrEditUrl(), {
						id: item.id,
						type: 2
					}, {
						token: true
					}).then(res => {
						let all = res.data;
						if (all.code == 1) {
							this.$message({
								message: this.$t('system.openSucc'),
								type: 'success'
							});
							this.getList()
						}
						
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			getBtnType(status){
				if(status==1){
					return 'success';
				}else if(status==0){
					return 'danger';
				}else if(status==3){
					return 'warning';
				}else{
					return 'info';
				}
			},
			changeAcStatus(data){
				this.form_remark = {
					id:data.id,
					status:data.status,
					remark:''
				}
			
				this.remarkModel = true
			},
			submitRemark(){
				this.$refs.form_remark.validate(res => {
					
					if (res) {
						this.changeAcStatusApi(this.form_remark)
					}
				})
			},
			changeAcStatusApi(data){
				//this.layout.loading = true;
				this.axios.post(this.changeStatusUrl(), {
					id: data.id,
					remark: data.remark,
					status: data.status,
					type: 'account_status',
				}, {
					token: true,
				}).then(res => {
					let all = res.data;
					console.log(all)
					if (all.code == 1) {
						this.$message({
							message:all.msg,
							type: 'success'
						});
						let index  = this.tableData.findIndex(item=>item.id == data.id)
						this.tableData[index].account_status = data.status
						if(data.status==2){
							this.getList()
						}
					}
					this.remarkModel = false
					//this.layout.loading = false;
				}).catch(err => {
					//this.layout.loading = false;
					this.$message.error(this.$t('system.openFailed'));
				});
			},
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToTotal(item){
				console.log(item)
				let search = {
					search:{
						domain:item.DomainName,
						stream:item.StreamName,
						appname:item.AppName,
						time:[]
					},
				}
				console.log(search)
				this.$router.push({
					name: 'live_total',
					params:search
				})
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changePassShowEmail(item){
				item.showPassEmail = item.showPassEmail==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						type:1,
						domain:'',
						appname:'live',
						stream:'',
						date:'',
					}
					if(this.agentData.tl.length!=0){
						this.form.domain = this.agentData.tl[0].domain
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						type:1,
						domain:e.DomainName,
						appname:e.AppName,
						stream:e.StreamName,
						date:'',
						
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			getPlayUrl(item){
				
				this.playModel = true
				
				this.playData.load = true
				this.axios.post('/admin/data/checkPlayUrl', {
					id:item.ld_id,
					AppName:item.AppName,
					StreamName:item.StreamName,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(list)
					this.playData.url = list.hls_url
					this.playData.load = false
					
					if (this.isDialogOpened) {
					      this.previewStream();
					    }
				}).catch(err => {
					// 失敗
					this.playData.load = false
				})
				
			},
			onDialogOpened() {
			    this.isDialogOpened = true;
			    // 如果接口数据已经回来，直接初始化播放器
			    if (this.playData.url) {
			      this.previewStream();
			    }
			  },
			  onDialogClosed() {
			    this.isDialogOpened = false;
			    this.destroyPlayer();
			    this.playData.url = ''; // 清空旧地址
			  },
			previewStream() {
			      // 加一个小延迟，确保 dialog 渲染动画结束
			        setTimeout(() => {
			          this.$nextTick(() => {
			            if (this.player) {
			              this.player.dispose();
			            }
			      
			            const videoElement = this.$refs.videoPlayer;
			            if (!videoElement || !document.body.contains(videoElement)) {
			              console.warn('video element not in DOM yet');
			              return;
			            }
			      
			            this.player = videojs(videoElement, {
			              autoplay: true,
			              controls: true,
			              preload: 'auto',
			              sources: [{
			                src: this.playData.url,
			                type: 'application/x-mpegURL'
			              }]
			            });
			          });
			        }, 200); // 加 200ms 延迟
			    },
			    destroyPlayer() {
			      if (this.player) {
			        this.player.dispose();
			        this.player = null;
			      }
			    },
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					
				
					
					
					
					this.layout.loading = false;
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.from.domain = e.domain
				this.info = e.info
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					stream: '',
					appname:'',
					domain:'',
					one:'',
					type:-1,
					time:this.getTodayRange()
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 高宽比 = 9 / 16 = 0.5625 */
}

.video-wrapper .video-js {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
